// extracted by mini-css-extract-plugin
export default {"main_block_damageList":"DamageList_main_block_damageList__5iNDC","add_damage_btn":"DamageList_add_damage_btn__56rwb","damage_list":"DamageList_damage_list__rU-fG"};